import { BlockReference } from '@/cms/types/block';
import { BlockComponentModel } from '@/cms/types/blok-component';

import GatedContent from './GatedContent';
import { CaptureUserDetailsProps } from './types';

export type GatedContentStrapiProps = BlockComponentModel<{
  gated_content_insert: BlockReference<CaptureUserDetailsProps>;
}>;

const GatedContentBlockStrapi = (props: GatedContentStrapiProps) => {
  if (!props?.block?.gated_content_insert?.data?.attributes) return null;

  return <GatedContent {...props.block.gated_content_insert.data.attributes} />;
};

export default GatedContentBlockStrapi;
